module.exports = __webpack_public_path__ + "img/finger-food-2.d8b9c658.jpg";